// LD will only check against these flags, so when new ones are added/remove update this object
// only will look at ones that are used in the sdk
// also update the useFlags hook to make sure it is gettings passed through
export const FeatureFlags = {
  'v-2-show-trade-partner-contracts': false,
  'v-2-show-build-tools': false,
  'v-2-admin-external-menu-link': false,
  'v-2-production-checklists': false,
  'v-2-production-punchlists': false,
  'v-2-field-walkthroughs': false,
  'v-2-neighborhoods': false,
  'v-2-development': false,
  'v-2-possessions': false,
  'v-2-specs': false,
  'v-2-users': false,
  'v-2-manage-tools': false,
  'v-2-plans': false,
  'v-2-color-schemes': false,
  'v-2-jobs': false,
  'v-2-parts': false,
  'v-2-options': false,
  'v-2-reports': false,
  'v-2-model-homes': false,
  'v-2-map-setup': false,
  'v-2-photo-approval': false,
  'v-2-schedule-templates': false,
  'bl-maintenance-mode': false,
  'v-2-site-reports': false,
  'zendesk-and-help-tools': false,
  'entra-id': false,
  'sales-closing-calendar': false,
  'under-contract': false,
  'client-view-build': false,
  'client-build-creation': false,
  'fwt-management': false,
  'contract-mark-up': false,
  'homeowner-closing-ceremonies': false,
  'closing-date-sage-overwrite': false,
  'sales-digital-contracting': false,
  'documentation-build-documentation': false,
  'uniform-login-page': false,
  'unified-user-management': false,
  'bulk-option-exclusions': false,
  'selects-page-sliding-menus': false,
  'sales-test-build': false,
  'sales-agent-lookup': false,
  'sales-incentive-repeater': false,
  'entra-user-creation-origin': false,
  'hide-place-order-page': false,
  'convert-to-entra-button': false,
  'create-return-po-button': false,
  'lot-premium-option-deposit-calculation': false,
  'manage-app-roles-page': false,
  'authorize-user-navigation-access': false,
  'fwt-plan-markup': false,
  'homeowner-portal-v-2': false,
  'build-communications-page': false,
  'warranty-question-page': false
};
